import { Button, Card, Col, Flex, Grid, message, Row, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";

import TreatmentAnalytics from "./treatmentAnalytics/TreatmentAnalytics";
import FinancialAnalytics from "./financialAnalytics/FinancialAnalytics";
import InsuranceAnalytics from "./insuranceAnalytics/InsuranceAnalytics";

import groth from "../../../assets/icons/presention-chart.svg";
import leftArrow from "../../../assets/icons/arrow-left.svg";
import userTag from "../../../assets/icons/user-tag.svg";
import people from "../../../assets/icons/people.png";

import { controller } from "./statisticsController";
import "./styles.css";

const {useBreakpoint} = Grid

export default function StatisticsMainLayout({ selectedBoardStatistics, setSelectedBoardStatistics }) {
  const [selectedAnalytics, setSelectedAnalytics] = useState("treatment");
  const [boardStatisticsData, setBoardStatisticsData] = useState(undefined);
  const [isGettingBoardStatisticsData, setIsGettingBoardStatisticsData] = useState(false);

  const screens = useBreakpoint();
  const isMobileView = !screens.md;

  useEffect(function () {
    async function getBoardStatisticsData() {
      try {
        setIsGettingBoardStatisticsData(true);

        const response = await controller.getStatisticsData(selectedBoardStatistics);

        if (response.status === 200) {
          setBoardStatisticsData(response.json);
        }
      } catch (err) {
        message.error("Something went wrong while getting board statistics data");
        console.error(err);
      } finally {
        setIsGettingBoardStatisticsData(false);
      }
    }
    getBoardStatisticsData();
  }, []);

  return (
    <div style={{ padding: 30 }}>
      <Flex vertical gap="large">
        <Flex justify="space-between">
          <Typography.Title level={4}>List Name's Analytics</Typography.Title>
          <Button
            style={{ border: "2px solid #6B43B5", padding: "10px 16px", color: "#6B43B5" }}
            onClick={() => setSelectedBoardStatistics(undefined)}
          >
            <img src={leftArrow} alt="left arrow" />
            Back
          </Button>
        </Flex>

        {/* Status Top Bar */}
        <Card size="small" style={{ padding: 5 }}>
          <Row gutter={[10,15]} justify="center">
            <StatusLabel icon={people} title="Total Patients" amount="70,000" />
            <StatusLabel icon={groth} title="Percentage Groth" amount="50%" />
            <StatusLabel icon={userTag} title="Monthly Active Patients" amount="30,000" />
          </Row>
        </Card>

        {/* Options Container */}
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 30,
          }}
        >
          <div
            style={{
              borderRadius: 100,
              boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
              padding: "7px",
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
            }}
          >
            <Button
              className={`treatment-financing-insurance-tabs ${selectedAnalytics === "treatment" ? "active" : ""} `}
              onClick={() => setSelectedAnalytics("treatment")}
              style={{ cursor: isGettingBoardStatisticsData ? "not-allowed" : "pointer" }}
              disabled={isGettingBoardStatisticsData}
            >
              {isMobileView ? "Treatment" : "Treatment Analytics"}
            </Button>
            <Button
              className={`treatment-financing-insurance-tabs ${selectedAnalytics === "financial" ? "active" : ""} `}
              onClick={() => setSelectedAnalytics("financial")}
              style={{ cursor: isGettingBoardStatisticsData ? "not-allowed" : "pointer" }}
              disabled={isGettingBoardStatisticsData}
            >
              {isMobileView ? "Financial" : "Financial Analytics"}
            </Button>
            <Button
              className={`treatment-financing-insurance-tabs ${selectedAnalytics === "insurance" ? "active" : ""} `}
              onClick={() => setSelectedAnalytics("insurance")}
              style={{ cursor: isGettingBoardStatisticsData ? "not-allowed" : "pointer" }}
              disabled={isGettingBoardStatisticsData}
            >
              {isMobileView ? "Insurance" : "Insurance Analytics"}
            </Button>
          </div>
        </div>

        <div>
          <Typography.Title level={4} style={{ textTransform: "capitalize", marginBottom: 30 }}>
            {selectedAnalytics} Analytics
          </Typography.Title>

          {isGettingBoardStatisticsData || !boardStatisticsData ? (
            <Flex align="center" justify="center" style={{ width: "100%" }}>
              <Spin size="large" />
            </Flex>
          ) : (
            <>
              {selectedAnalytics === "treatment" && <TreatmentAnalytics boardStatisticsData={boardStatisticsData} />}
              {selectedAnalytics === "financial" && <FinancialAnalytics boardStatisticsData={boardStatisticsData} />}
              {selectedAnalytics === "insurance" && <InsuranceAnalytics boardStatisticsData={boardStatisticsData} />}
            </>
          )}
        </div>
      </Flex>
    </div>
  );
}

function StatusLabel({ icon, title, amount }) {
  return (
    <Col xs={24} md={12} xl={8} >
      <div style={{ height: 112, padding: 17, backgroundColor: "#DFDAFFB2", display: "flex", gap: 12, borderRadius: 8, alignItems: "center", flexDirection: "row" }}>
        <div
          style={{
            width: 73,
            height: 73,
            backgroundColor: "#7F59CE",
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={icon} alt={icon} />
        </div>

        <div style={{ marginLeft: 20 }}>
          <p style={{ color: "#4D3280", fontSize: 16 }}>{title}</p>
          <p style={{ color: "#4D3280", fontSize: 24, marginBottom: 0 }}>{amount}</p>
        </div>
      </div>
    </Col>
  );
}
